import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingProfileLookup extends Layout {
    sourceInvoiceProcessingProfile: DataSource;
    tableLookup: Table;
}
